<section>
  <div>
    <div class="row mx-0 py-1">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="ms-0">
          {{ isFormView ? 'Registrar detalle solicitud de nota' : 'Detalle solicitud de nota' }}
        </h6>
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledActions"
          [width]="'7rem'" (onClick)="openRegister()"></app-custom-button>
      </div>
    </div>
    <div class="row mx-0">
      <ng-container *ngIf="!disabledActions && !headerChanged">
        <div class="pb-2" *ngIf="noteModel.isLevelArticle" [hidden]="!isFormView">
          <app-register-note-detail-article [noteModel]="noteModel" [noteDetailContract]="noteDetail"
            [isDocumentSupport]="false" (noteContract)="getNote($event)" (newNoteDetail)="getNoteDetail($event)"
            (updateListDetail)="getUpdateListDetail()" (isFormView)="getFormDetailView($event)">
          </app-register-note-detail-article>
        </div>
        <div class="pb-2" *ngIf="!noteModel.isLevelArticle" [hidden]="!isFormView">
          <app-register-note-detail-concept [noteConceptDetailResponse]="noteConceptDetailResponse"
            [noteModel]="noteModel" (newNoteConceptDetailResponse)="getNoteConceptDetailResponse($event)"
            (updateListDetail)="getUpdateListDetail()" (noteContract)="getNote($event)"
            (isFormView)="getFormDetailView($event)">
          </app-register-note-detail-concept>
        </div>
      </ng-container>
    </div>
    <tr *ngIf="headerChanged">
      <td class="px-6 py-10 text-center">
        <div class="vw-100 p-4 d-flex flex-column align-items-center justify-content-center">
          <p class="m-0 text-secondary fs-6 d-flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-circle text-warning me-2" style="font-size: 1.2rem;"></i>
            Es necesario guardar los datos del encabezado para acceder al formulario de detalle.
          </p>
        </div>
      </td>
    </tr>
    <div class="">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
          [showCheckbox]="!disabledActions" [checkBoxAction]="checkboxActions"
          [clearSelectionTrigger]="clearSelectionTrigger" (onAction)="onAction($event)"
          (onRecoverData)="getUpdateListDetail()" (onPageChange)="onPageChange($event)">
        </app-custom-table>
      </div>
    </div>
  </div>
</section>